// authSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AppState {
  isAppInitialize: boolean;
  companyId: string | null;
  marketplaceName: string | null;
  isSidebarOpen: boolean;
}

const initialState: AppState = {
  isAppInitialize: false,
  companyId: null,
  marketplaceName: null,
  isSidebarOpen: true,
};

const appSlice = createSlice({
  name: "company",
  initialState,
  reducers: {
    appInitializationCompleted: (state) => {
      state.isAppInitialize = true;
    },
    appInitializationReset: (state) => {
      state.isAppInitialize = false;
    },
    setCompanyId: (state, action: PayloadAction<string | null>) => {
      state.companyId = action.payload;
    },
    setMarketplaceName: (state, action: PayloadAction<string | null>) => {
      state.marketplaceName = action.payload;
    },
    resetApp: (state) => {
      console.log("reset app call");
      state.companyId = null;
      state.isAppInitialize = false;
      state.marketplaceName = null;
    },
    toggleSidebar: (state) => {
      state.isSidebarOpen = !state.isSidebarOpen;
    },
  },
});

export const {
  appInitializationCompleted,
  setCompanyId,
  setMarketplaceName,
  appInitializationReset,
  resetApp,
  toggleSidebar,
} = appSlice.actions;

export default appSlice.reducer;
